import { render, staticRenderFns } from "./modal-automation-academic-references.vue?vue&type=template&id=71a06e96&scoped=true&"
import script from "./modal-automation-academic-references.vue?vue&type=script&lang=js&"
export * from "./modal-automation-academic-references.vue?vue&type=script&lang=js&"
import style0 from "./modal-automation-academic-references.vue?vue&type=style&index=0&id=71a06e96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a06e96",
  null
  
)

export default component.exports